import { Stack, Typography } from '@mui/material'
import { useContext } from 'react'
import * as Yup from 'yup'
import { AdminModalContext } from '../../../../contexts/AdminModalContexts'
import Modal from '../../../molecules/Modal'
import { ValidatedButton, ValidatedForm, ValidatedTextInput } from '../../../organisms/validation/admin'

const validationSchema = Yup.object().shape({
    inventory_name: Yup.string().required()
})

export default function CreateInventoryModal() {

    const {currentModal, setCurrentModal} = useContext(AdminModalContext)
    
    return (
        <Modal
            visible={currentModal === "create_inventory"}
            title={"New Inventory"}
            subtitle={"Complete the form to create a new inventory."}
            setVisibility={()=>setCurrentModal("")}
        >
            <ValidatedForm
                initialValues={{}}
                validationSchema={validationSchema}
                onSubmit={()=>{}}
            >
                <>
                    <Stack sx={{width: "100%"}}>
                        <Typography variant="subtitle2" color="white">Inventory name</Typography>
                        <ValidatedTextInput placeholder="name" name="inventory_name" type="text" />
                    </Stack>

                    <div className="flex justify-end mt-4 w-full">
                        <ValidatedButton 
                            // startIcon={<GrPowerCycle />} 
                            variant="contained" 
                            color="secondary" 
                            disableElevation={true}
                            loading={false}
                            disabled={false}
                        >
                            <Typography  color="primary" sx={{fontSize:"13px"}} >Submit</Typography>
                        </ValidatedButton>
                    </div>
                </>
            </ValidatedForm>

        </Modal>
    )
}
